/* Track Downloads & Outbound Links in Google Analytics */
/********************************************************/
var filetypes = /\.(zip|pdf|doc|docx|xls|xlsx|ppt|pptx|mp3|mp4|txt|rar|wma|mov|avi|wmv|flv|wav|cfg|dwg|igs|par|rfa|sat|stp)$/i;
var baseHref = '';
if ($('base').attr('href') !== undefined) baseHref = $('base').attr('href');
$('a').on('click', function (event) {
    var el = $(this);
    var track = true;
    var href = (typeof (el.attr('href')) != 'undefined') ? el.attr('href') : "";
    var isThisDomain = href.match(document.domain.split('.').reverse()[1] + '.' + document.domain.split('.').reverse()[0]);
    if (!href.match(/^javascript:/i)) {
        var elEv = [];

        elEv.value = 0;
        elEv.non_i = false;

        if (href.match(/^mailto\:/i)) {
            elEv.category = "email";
            elEv.action = "click";
            elEv.label = href.replace(/^mailto\:/i, '');
            elEv.loc = href;
        } else if (href.match(filetypes)) {
            var extension = (/[.]/.exec(href)) ? /[^.]+$/.exec(href) : undefined;
            elEv.category = "download";
            elEv.action = "click-" + extension[0];
            elEv.label = href.replace(/ /g, "-");
            elEv.loc = baseHref + href;
        } else if (href.match(/^https?\:/i) && !isThisDomain) {
            elEv.category = "external";
            elEv.action = "click";
            elEv.label = href.replace(/^https?\:\/\//i, '');
            elEv.non_i = true;
            elEv.loc = href;
        } else if (href.match(/^tel\:/i)) {
            elEv.category = "telephone";
            elEv.action = "click";
            elEv.label = href.replace(/^tel\:/i, '');
            elEv.loc = href;
        } else track = false;
        if (track) {
            if (typeof gtag === 'function') {
                gtag('event', elEv.action.toLowerCase(), {
                    'event_category': elEv.category.toLowerCase(),
                    'event_label': elEv.label.toLowerCase(),
                    'value': elEv.value,
                    'non_interaction': elEv.non_i,
                    'transport_type': 'beacon',
                    'event_callback': function () {
                        document.location = href;
                    }
                });

                if (el.attr('target') === undefined || el.attr('target').toLowerCase() != '_blank') {
                    setTimeout(function () {
                        location.href = elEv.loc;
                    }, 400);
                    return false;
                }
            }
        }
    }
});